import React from 'react';
import { Select } from 'antd';
import moment from 'moment';

import { Alert, Button, Flex, Tag } from '~/ui/components';
import { ContractCondition } from '~/typings/entities/ContractCondition';

import { useContractCondition } from './ConditionContext';
import { conditionLabel } from './conditionData';
import { BannerContent, Caption, Counter, OptionPeriod, Wrapper } from './ConditionBar.styled';

const formatPeriod = (condition: ContractCondition): string => {
  const from = condition.startDate ? moment(condition.startDate).format('DD/MM/YYYY') : '—';
  return condition.endDate ? `${from} até ${moment(condition.endDate).format('DD/MM/YYYY')}` : `desde ${from}`;
};

export function ConditionBar() {
  const { conditions, selectedCondition, isViewingCurrent, selectCondition, backToCurrent } = useContractCondition();

  if (!conditions.length || !selectedCondition) return null;

  const endedAt = selectedCondition.endDate ? moment(selectedCondition.endDate).format('DD/MM/YYYY') : '—';
  const bannerMessage =
    `Você está vendo a condição v${selectedCondition.version}, encerrada em ${endedAt}. ` +
    'Os dados abaixo não refletem o contrato vigente.';

  return (
    <Flex direction="column" width="100%">
      <Wrapper>
        <Caption>CONDIÇÃO DO CONTRATO</Caption>
        <Select
          value={selectedCondition.ccb}
          onChange={selectCondition}
          style={{ minWidth: 320, maxWidth: '100%' }}
          dropdownMatchSelectWidth={false}
          optionLabelProp="title"
          aria-label="Condição do contrato"
        >
          {conditions.map((condition) => (
            <Select.Option key={condition.ccb} value={condition.ccb} title={conditionLabel(condition)}>
              {conditionLabel(condition)}
              <OptionPeriod>{`· ${formatPeriod(condition)}`}</OptionPeriod>
            </Select.Option>
          ))}
        </Select>
        <Tag color={selectedCondition.current ? 'positive' : 'alert'}>
          {selectedCondition.current ? '• Vigente' : '• Encerrada'}
        </Tag>
        {conditions.length > 1 && <Counter>{`${conditions.length} condições desde a contratação`}</Counter>}
      </Wrapper>
      {!isViewingCurrent && (
        <Alert
          status="warning"
          fullWidth
          renderValue={
            <BannerContent>
              <span>{bannerMessage}</span>
              <Button size="sm" onClick={backToCurrent}>
                Voltar à condição vigente
              </Button>
            </BannerContent>
          }
        />
      )}
    </Flex>
  );
}
